import React, { PropTypes } from 'react'
import classnames from 'classnames'

import { IconSubmit } from 'icons'

import styles from './Spinner.scss'

const Spinner = ({ className, colour, size }) => {
  return (
    <IconSubmit className={classnames(styles.base, className, styles[colour], styles[size])} />
  )
}

Spinner.propTypes = {
  className: PropTypes.string,
  colour: PropTypes.oneOf(['green', 'grey', 'white']),
  size: PropTypes.oneOf(['xSmall', 'small', 'medium', 'large']),
}

Spinner.defaultProps = {
  className: null,
  colour: 'green',
  size: 'small',
}

export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js